const BaseURL = process.env.REACT_APP_API_KEY_DEV_MODE
const userId = process.env.REACT_APP_USERNAME
const password = process.env.REACT_APP_PASSWORD

export const GenerateTokenAPI = async () => {
    const apiUrl = `${BaseURL}/api/User/token`
    const body = {
        "userId": userId,
        "userPassword": password
      };

    try {
        const result = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });

        if (!result.ok) {
            throw new Error(`HTTP error! Status : ${result.status}`);
        }
        const data = await result.json();
        return data;

    } catch (error) {
        console.log(error);
    }
};
